import useAxios from 'axios-hooks';
import { AxiosPromise } from 'axios';
import { AxiosMethod, defaultAxiosOptions } from '../../../constants';
import { ResponseValuesOverride } from '../../../models/response-values-override';

export function useDeleteOfferGeoSchedules(
  endpoint: (id: string) => string,
): [ResponseValuesOverride<string>, (id: string) => AxiosPromise<string>] {
  const [resp, execute] = useAxios<string>(
    {},
    {
      ...defaultAxiosOptions,
    },
  );

  const remove = (id: string) =>
    execute({
      method: AxiosMethod.Delete,
      url: endpoint(id),
    });

  return [resp, remove];
}
